import { createMasterScreen } from '../../../components/erp/ERPMasterScreenFactory';
export default createMasterScreen({
  title: 'Style Master', screenId: '4.3.6', module: 'Procurement', apiPath: 'style', screenName: 'StyleMaster', idField: 'StyleId', nameField: 'StyleName',
  gridColumns: [{ field: 'StyleId', header: 'Style ID' }, { field: 'StyleName', header: 'Style Name' }],
  formFields: [{ field: 'StyleId', label: 'Style Id', disabled: true }, { field: 'StyleName', label: 'Style Name', required: true }]
});
